<template>
  <div class="sddsf">
    <headerBlack-view></headerBlack-view>
    <div class="sddsf_menu flex-align">
      <span>首页</span>
      <div>/</div>
      <span>云桥概况</span>
      <div>/</div>
      <span>“首都带首府”详情</span>
    </div>
    <div class="sddsf_content">
      <div class="content_top">
        <div class="title flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>“首都带首府”京银合作“互联网+教育”模式</span>
            <img src="@/assets/yunqiao/sddsf.png" />
          </div>
        </div>
        <div class="pattern flex-layout">
          <div>是</div>
          <div>
            依托北京市政府、北京市教委，立足于首都优势资源，依托首都师范大学将优质资源通
            过“互联网+”的形态归集，并形成生态向全国帮扶地区输出。
          </div>
        </div>
        <div class="pattern flex-layout pattern2">
          <div>目</div>
          <div>
            前，“首都带首府”已经面向全国开展工程建设，已完成并投入实施的项目包括：《“首都带首府”京银“互联网+教育”首都师范大学“双优云桥”项目》、“新疆和田推广普通话项目”，共计为8万人次提供研修服务。
            两个项目是面向当地地区师生提供“教师教育能力提升”和“学生综合素养提升”的研修类项目，借助“互联网+”技术能力为当地师生提供在线的便捷教育服务，同时达到高效高质量的学习成果，得到参训师生的一致好评。
          </div>
        </div>
        <div class="pattern flex-layout">
          <div>首</div>
          <div>都带首府将旨在为更多的帮扶地区提供更多优质的教育资源，并协助地区形成资源整合，实现教育资源生态的建设，最终达到共同进步的社会意义。</div>
        </div>
        <div class="area flex-align-around">
          帮扶
          <br />地区
        </div>
        <div class="area2 flex-align-around">
          帮扶
          <br />地区
        </div>
        <div class="area3 flex-align-around">首都带首府</div>
        <!-- <div class="area"></div> -->
        <!-- <div></div> -->
      </div>
      <div class="content_bottom flex-column-center">
        <div class="construction_pattern">
          <div>“首都带首府”京银合作“互联网+教育”模式</div>
        </div>
        <div class="arrows01">
          <img src="@/assets/yunqiao/arrows02.png" />
        </div>
        <div class="pattern_wrap flex-align-between">
          <div class="pattern_left flex-align-around">
            <div>
              “首都带首府”京银“互联网+教育” <br>
              首都师范大学“双优云桥”项目
            </div>
          </div>
          <div class="pattern_right flex-align-around">
            <div>新疆和田推广普通话项目</div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@import "./less/detail_sddsf.less";
</style>